import { useEffect } from "react";
import { useSignal } from "@preact/signals-react";

import Dialog from "componentsv2/modal/Dialog";
import NotesModal from "components/Meta/NotesModal";
import { useNotesModal } from "components/Meta/notesModalStore";

function NotesModalContent({ onReload }) {
  const { open, record, onSaved, title, close } = useNotesModal();
  const openSignal = useSignal(open);

  useEffect(() => {
    openSignal.value = open;
  }, [open]);

  function handleSaved(hasUnread) {
    onSaved?.(hasUnread);
    onReload?.();
  }

  return (
    <Dialog
      title={title ?? "sale.sale.notes"}
      openModal={openSignal}
      handleClose={close}
    >
      {open && record && (
        <NotesModal record={record} onSaved={handleSaved} onClose={close} />
      )}
    </Dialog>
  );
}

export default NotesModalContent;
